import {
  Modal,
  Grid,
  Typography,
  Paper,
  Box,
  Skeleton,
  IconButton,
  Divider,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getEndCustomerPrintedByID } from "API/swesum";
import InfoField from "Components/Invoice/InfoField";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

const containerStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "1300px",
  width: "100%",
  borderRadius: "10px",
  boxShadow:
    "0px 5px 6px -3px rgba(0,0,0,0.2), 0px 9px 12px 1px rgba(0,0,0,0.14)",
};

const EndcustomerAccountModal = ({ open, onClose, endcustomerAccount }) => {
  const [printedInvoice, setPrintedInvoice] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const asyncFetchPrinted = async () => {
      setLoading(true);
      if (endcustomerAccount.PrintedId > 0) {
        const res = await getEndCustomerPrintedByID(
          endcustomerAccount.PrintedId
        );
        if (res) {
          setPrintedInvoice(res);
        }
      } else {
        setPrintedInvoice(null);
      }
      setLoading(false);
    };

    if (endcustomerAccount) {
      asyncFetchPrinted();
    }
  }, [endcustomerAccount]);

  if (!open) {
    return null;
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Paper sx={containerStyle}>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Grid item container flexDirection={"column"} p={6}>
          <Typography
            color={"black"}
            fontSize={18}
            textAlign="left"
            fontWeight={"bold"}
            align="left"
          >
            Slutkundshändelse
          </Typography>
          <Grid container item mb={3} rowGap={2}>
            <Grid item container columnGap={15}>
              <InfoField
                loading={loading}
                label={"Kund"}
                value={printedInvoice?.EndCustomerName}
              />
              <InfoField
                loading={loading}
                label={"Kundnummer"}
                value={printedInvoice?.EndCustomerExternalCustomerNo}
              />
              <InfoField
                loading={loading}
                label={"Org. nr"}
                value={printedInvoice?.EndCustomerOrgNo}
              />
              <InfoField
                loading={loading}
                label={"Email"}
                value={printedInvoice?.EndCustomerInvoiceEmail}
              />
            </Grid>
            <Grid item container columnGap={15}>
              <InfoField
                loading={loading}
                label={"Adress"}
                value={printedInvoice?.EndCustomerAddress}
              />
              <InfoField
                loading={loading}
                label={"Adress2"}
                value={printedInvoice?.EndCustomerAddress2}
              />
              <InfoField
                loading={loading}
                label={"Postnummer"}
                value={printedInvoice?.EndCustomerPostalCode}
              />
              <InfoField
                loading={loading}
                label={"Stad"}
                value={printedInvoice?.EndCustomerCity}
              />
            </Grid>
          </Grid>
          <Divider sx={{ mb: 3 }} />
          <Typography
            color={"black"}
            fontSize={18}
            textAlign="left"
            fontWeight={"bold"}
            align="left"
          >
            Fakturainformation
          </Typography>
          <Grid item container mb={3} rowGap={2}>
            <Grid item container columnGap={15}>
              <InfoField
                loading={loading}
                label={"OCR"}
                value={printedInvoice?.OCR}
              />
              <InfoField
                loading={loading}
                label={"Belopp"}
                value={
                  printedInvoice?.ConnectedAmount ||
                  printedInvoice?.ConnectedAmount === 0
                    ? `${printedInvoice?.ConnectedAmount} :-`
                    : "-"
                }
              />
              <InfoField
                loading={loading}
                label={"Utskriven"}
                value={dayjs(endcustomerAccount.BookingDate).format(
                  "YYYY-MM-DD"
                )}
              />
              <InfoField
                loading={loading}
                label={"Fakturanummer"}
                value={printedInvoice?.ExternalInvoiceNumber}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item ml={6} mb={3} onClick={onClose}>
          <Button variant="contained">Stäng</Button>
        </Grid>
      </Paper>
    </Modal>
  );
};

export default EndcustomerAccountModal;
